<template>
  <div>
    <div v-if="!contest" style="width=100%;">Loading</div>

    <div class="md-layout" v-if="contest">
      <div
        v-if="listOrCandidates === 'CANDIDATES' && visibleContest"
        :class="
          'md-layout md-gutter grid-container-' +
            contest.ChoicesContest[0].Presentation.NumColumns
        "
      >
        <!-- <div
          v-for="(column, index) in candidates"
          :key="'x-' + index + '-' + column[0].CandidateIdentifier.Id"
          class="md-layout-item"
        >
          <div
            v-for="candidate in column"
            :key="'y-' + candidate.CandidateIdentifier.Id"
            class="md-layout-item"
          > -->
        <candidate
          v-for="candidate in candidates"
          :candidate="candidate"
          @candidateSelected="candidateSelected"
          :disabled="disabled"
          :sexVoted="sexVoted"
          :electionId="electionId"
          :previousVoted="previousVoted"
          ref="cand"
          :key="'candidate-' + candidate.CandidateIdentifier.Id"
        >
        </candidate>
        <!-- </div>
        </div> -->
      </div>

      <div
        v-if="listOrCandidates === 'AFFILIATIONS'"
        :class="
          'md-layout md-gutter grid-container-' +
            contest.ChoicesContest[0].Presentation.NumColumns
        "
      >
        <affiliation
          v-for="affiliation in affiliations"
          :affiliation="affiliation"
          @affiliationSelected="affiliationSelected"
          @affiliationConfirmed="affiliationConfirmed"
          @hasContest="hasContest"
          :disabled="disabled"
          :electionType="electionType"
          :sexVoted="sexVoted"
          :electionName="electionName"
          :electionId="electionId"
          :key="'affiliation-' + affiliation.AffiliationIdentifier.Id"
        >
        </affiliation>
        <!-- </div> -->
        <!-- </div> -->
      </div>
      <!-- "ReferendumOption":null,
            "Contested":null,
            "Partisan":null -->
    </div>
  </div>
</template>

<script>
import Candidate from "./Candidate";
import Affiliation from "./Affiliation";

export default {
  name: "Contest",
  async mounted() {
    if (
      this.semaphore-- &&
      (this.loadDeferredContest == "false" || this.loadContest == true)
    ) {
      await this.getContest();
      this.loaded = true;
    }
  },
  data: function() {
    return {
      contest: null,
      candidates: {},
      affiliations: {},
      loaded: false,
      semaphore: 1
    };
  },
  props: [
    "contestId",
    "disabled",
    "electionType",
    "listOrCandidates",
    "sexVoted",
    "electionName",
    "electionId",
    "previousVoted",
    "loadContest",
    "visibleContest",
    "loadDeferredContest"
  ],
  watch: {
    async loadContest(val) {
      if (!this.loaded && val == true && this.loadDeferredContest != "false") {
        await this.getContest();
        this.loaded = true;

        this.$forceUpdate();
      }
      this.$emit("contestRetrieved");
    }
  },
  methods: {
    async getContest() {
      let contest = await this.$store.state.ceoCbbService.getContest(
        this.$store.state.voterIdentification.EventIdentifier.Id,
        this.contestId,
        this.$store.state.voterIdentification.Voter.VoterIdentifier.VoterId[0]
      );

      if (contest.error) {
        //(contest.error);
        alert(contest.error + "\n\n" + this.$store.state.alertMessage);
        return;
      }

      this.contest = contest;

      this.$emit("contestRetrieved", {
        id: this.contestId,
        name:
          contest.ChoicesContest[0].ChoicesContestIdentifier.ContestName ||
          contest.ChoicesContest[0].ChoicesContestIdentifier.Id
      });
      if (this.listOrCandidates === "CANDIDATES") {
        this.candidates = contest.ChoicesContest[0].BallotChoices.Candidate;
        this.$emit("num-cand-or-aff", this.candidates.length);
        // this.orderCandidates(
        //   contest.ChoicesContest[0].BallotChoices.Candidate,
        //   contest.ChoicesContest[0].Presentation.NumColumns
        // );
      }
      if (this.listOrCandidates === "AFFILIATIONS") {
        this.affiliations = contest.ChoicesContest[0].BallotChoices.Affiliation;
        this.$emit("num-cand-or-aff", this.affiliations.length);
        // this.orderAffiliations(
        //   contest.ChoicesContest[0].BallotChoices.Affiliation,
        //   contest.ChoicesContest[0].Presentation.NumColumns
        // );
      }
    },
    orderCandidates(candidates, columns) {
      // TODO: brutto, rifare
      let ordered = candidates.sort((a, b) => {
        a.CandidateIdentifier.DisplayOrder > b.CandidateIdentifier.DisplayOrder
          ? 1
          : -1;
      });
      for (let k = 0; k < ordered.length; k = k + columns) {
        for (let i = 0; i < columns; i++) {
          if (!this.candidates[i]) this.candidates[i] = [];
          if (ordered[k + i]) this.candidates[i].push(ordered[k + i]);
        }
      }
    },
    orderAffiliations(affiliations, columns) {
      // TODO: brutto, rifare
      let ordered = [];
      try {
        ordered = affiliations.sort((a, b) => {
          a.Profile.DisplayOrder > b.Profile.DisplayOrder ? 1 : -1;
        });
      } catch (err) {
        ordered = affiliations;
      }
      for (let k = 0; k < ordered.length; k = k + columns) {
        for (let i = 0; i < columns; i++) {
          if (!this.affiliations[i]) this.affiliations[i] = [];
          if (ordered[k + i]) this.affiliations[i].push(ordered[k + i]);
        }
      }
    },
    candidateSelected(evt) {
      evt.contestId = this.contestId;
      this.$emit("candidateInContestSelected", evt);
    },
    affiliationSelected(evt) {
      evt.contestId = this.contestId;
      this.$emit("affiliationInContestSelected", evt);
    },
    affiliationConfirmed(evt) {
      evt.contestId = this.contestId;
      this.$emit("affiliationConfirmed", evt);
    },
    hasContest() {
      this.$emit("hasContest");
    }
  },
  components: {
    Candidate,
    Affiliation
  }
};
</script>
<style scoped>
.layout {
  width: 100% !important;
  max-width: 100% !important;
}

.md-button.md-theme-default.md-primary,
.md-button.md-theme-default.md-primary .md-icon-font {
  color: var(--pcolor) !important;
  color: var(
    --md-theme-default-primary-on-background,
    var(--pcolor)
  ) !important;
}

.grid-container-1 {
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-auto-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 5px;
}

.grid-container-2 {
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 5px;
}

.grid-container-3 {
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 5px;
}
</style>
